import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, take } from 'rxjs/operators';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';

@Component({
  selector: 'cigna-dialog-update-lob-pref',
  templateUrl: './dialog-update-lob-pref.component.html',
  styleUrls: ['./dialog-update-lob-pref.component.scss'],
})
export class DialogUpdateLobPrefComponent implements OnInit {
  preferredLobOptions$ = this.manageAccessFacade.preferredLobOptions$;
  updateUserTinSuccess$ = this.manageAccessFacade.updateUserTinSuccess$;
  userTinLobLoading$ = this.manageAccessFacade.userTinLobLoading$;
  preferredLOBs: { [key: string]: string } = {
    BOTH: 'Medical/Behavioral',
    CHCP: 'Medical',
    EBH: 'Behavioral',
  };
  lobPrefForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogUpdateLobPrefComponent>,
    private manageAccessFacade: ManageUserAccessFacade,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userId: string;
      lobPref: string;
      firstName: string;
      lastName: string;
    },
  ) {
    this.lobPrefForm = this.fb.group({
      lobControl: [
        this.data.lobPref === 'TBD' ? '' : this.data.lobPref,
        Validators.required,
      ],
    });
  }

  get lobControl(): FormControl {
    return this.lobPrefForm.get('lobControl') as FormControl;
  }

  ngOnInit() {
    this.manageAccessFacade.getUserTinLOB(this.data.userId);
    this.updateUserTinSuccess$
      .pipe(
        filter((success) => success),
        take(1),
      )
      .subscribe((success) => {
        if (success) {
          this.dialogRef.close();
        }
      });
  }

  updateUserTinLob() {
    this.manageAccessFacade.updateUserTinLOB(
      this.data.userId,
      this.lobControl.value,
    );
  }
}
